<template>
  <div id="app">
    <toolbar :ver="appVer"></toolbar>
    <router-view class="view" />
    <notifications group="note" width="100%" position="top center" classes="whtBrd-style" />
  </div>
</template>

<script>
import Toolbar from '@/components/toolbar'

export default {
  name: 'app',
  components: {
    Toolbar
  },
  data () {
    return {
      showBack: false,
      appVer: this.$appVer
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
//import custm theme before default bootstrap
@import '/assets/theme/sandstone-vars.scss';
@import '/assets/theme/sandstone-bootswatch.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

.view {
  margin-top: 5em;
}


.fa-icon {
  width: auto;
  height: 1.2em; 
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 3px;
}
.whtBrd-style {
  font-size: 18px;
  padding: 15px 5px 15px 10px;
  margin: 0px;
  color: white;
  font-weight: bold;
}
.whtBrd-style.save {
  background: #007BFF;
  border-left: 0px solid #111;
  text-align: center;
}
.whtBrd-style.signUp-success {
  background: #68CD86;
  border-left: 0px solid #111;
  text-align: center;
}
.whtBrd-style.warn {
  background: #ffb648;
  border-left-color: #f48a06;
}
.whtBrd-style.error {
  background: #E54D42;
  border-left-color: #B82E24;
}
.whtBrd-style.success {
  background: #68CD86;
  border-left-color: #42A85F;
}

</style>



// WEBPACK FOOTER //
// src/App.vue